/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AsyncDownloadScanRequest,
    AsyncDownloadScanRequestFromJSON,
    AsyncDownloadScanRequestToJSON,
} from '../models/AsyncDownloadScanRequest';
import {
    type AsyncS3ScanRequest,
    AsyncS3ScanRequestFromJSON,
    AsyncS3ScanRequestToJSON,
} from '../models/AsyncS3ScanRequest';
import {
    type CallbackFailures,
    CallbackFailuresFromJSON,
    CallbackFailuresToJSON,
} from '../models/CallbackFailures';
import {
    type ScanResult,
    ScanResultFromJSON,
    ScanResultToJSON,
} from '../models/ScanResult';
import {
    type SyncDownloadScanRequest,
    SyncDownloadScanRequestFromJSON,
    SyncDownloadScanRequestToJSON,
} from '../models/SyncDownloadScanRequest';
import {
    type SyncS3ScanRequest,
    SyncS3ScanRequestFromJSON,
    SyncS3ScanRequestToJSON,
} from '../models/SyncS3ScanRequest';
import {
    type Usage,
    UsageFromJSON,
    UsageToJSON,
} from '../models/Usage';
import {
    type Whoami,
    WhoamiFromJSON,
    WhoamiToJSON,
} from '../models/Whoami';

export interface CallbackFailuresGetRequest {
    callbackUrl: string;
    cursor?: string;
}

export interface ScanAsyncDownloadPostRequest {
    asyncDownloadScanRequest: AsyncDownloadScanRequest;
}

export interface ScanAsyncResultGetRequest {
    traceId: string;
}

export interface ScanAsyncS3PostRequest {
    asyncS3ScanRequest: AsyncS3ScanRequest;
}

export interface ScanSyncBinaryPostRequest {
    body: Blob;
}

export interface ScanSyncDownloadPostRequest {
    syncDownloadScanRequest: SyncDownloadScanRequest;
}

export interface ScanSyncS3PostRequest {
    syncS3ScanRequest: SyncS3ScanRequest;
}

/**
 * 
 */
export class AttachmentAVApi extends runtime.BaseAPI {

    /**
     * Creates request options for callbackFailuresGet without sending the request
     */
    async callbackFailuresGetRequestOpts(requestParameters: CallbackFailuresGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['callbackUrl'] == null) {
            throw new runtime.RequiredError(
                'callbackUrl',
                'Required parameter "callbackUrl" was null or undefined when calling callbackFailuresGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['callbackUrl'] != null) {
            queryParameters['callback_url'] = requestParameters['callbackUrl'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/callback/failures`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List callback failures
     */
    async callbackFailuresGetRaw(requestParameters: CallbackFailuresGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CallbackFailures>> {
        const requestOptions = await this.callbackFailuresGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CallbackFailuresFromJSON(jsonValue));
    }

    /**
     * List callback failures
     */
    async callbackFailuresGet(requestParameters: CallbackFailuresGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CallbackFailures> {
        const response = await this.callbackFailuresGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for scanAsyncDownloadPost without sending the request
     */
    async scanAsyncDownloadPostRequestOpts(requestParameters: ScanAsyncDownloadPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['asyncDownloadScanRequest'] == null) {
            throw new runtime.RequiredError(
                'asyncDownloadScanRequest',
                'Required parameter "asyncDownloadScanRequest" was null or undefined when calling scanAsyncDownloadPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scan/async/download`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AsyncDownloadScanRequestToJSON(requestParameters['asyncDownloadScanRequest']),
        };
    }

    /**
     * Download a file from a remote location (HTTP/HTTPS), scan the file, and post the scan result to your callback URL.
     */
    async scanAsyncDownloadPostRaw(requestParameters: ScanAsyncDownloadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.scanAsyncDownloadPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download a file from a remote location (HTTP/HTTPS), scan the file, and post the scan result to your callback URL.
     */
    async scanAsyncDownloadPost(requestParameters: ScanAsyncDownloadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.scanAsyncDownloadPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for scanAsyncResultGet without sending the request
     */
    async scanAsyncResultGetRequestOpts(requestParameters: ScanAsyncResultGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['traceId'] == null) {
            throw new runtime.RequiredError(
                'traceId',
                'Required parameter "traceId" was null or undefined when calling scanAsyncResultGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['traceId'] != null) {
            queryParameters['trace_id'] = requestParameters['traceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scan/async/result`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve the scan result for scan job.
     */
    async scanAsyncResultGetRaw(requestParameters: ScanAsyncResultGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScanResult>> {
        const requestOptions = await this.scanAsyncResultGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScanResultFromJSON(jsonValue));
    }

    /**
     * Retrieve the scan result for scan job.
     */
    async scanAsyncResultGet(requestParameters: ScanAsyncResultGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScanResult> {
        const response = await this.scanAsyncResultGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for scanAsyncS3Post without sending the request
     */
    async scanAsyncS3PostRequestOpts(requestParameters: ScanAsyncS3PostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['asyncS3ScanRequest'] == null) {
            throw new runtime.RequiredError(
                'asyncS3ScanRequest',
                'Required parameter "asyncS3ScanRequest" was null or undefined when calling scanAsyncS3Post().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scan/async/s3`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AsyncS3ScanRequestToJSON(requestParameters['asyncS3ScanRequest']),
        };
    }

    /**
     * Download a file from S3, scan the file, and post the scan result to your callback URL. A bucket policy is required to grant attachmentAV access to the S3 objects.
     */
    async scanAsyncS3PostRaw(requestParameters: ScanAsyncS3PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.scanAsyncS3PostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download a file from S3, scan the file, and post the scan result to your callback URL. A bucket policy is required to grant attachmentAV access to the S3 objects.
     */
    async scanAsyncS3Post(requestParameters: ScanAsyncS3PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.scanAsyncS3PostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for scanSyncBinaryPost without sending the request
     */
    async scanSyncBinaryPostRequestOpts(requestParameters: ScanSyncBinaryPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling scanSyncBinaryPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scan/sync/binary`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Upload a file, scan the file, and return the scan result.
     */
    async scanSyncBinaryPostRaw(requestParameters: ScanSyncBinaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScanResult>> {
        const requestOptions = await this.scanSyncBinaryPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScanResultFromJSON(jsonValue));
    }

    /**
     * Upload a file, scan the file, and return the scan result.
     */
    async scanSyncBinaryPost(requestParameters: ScanSyncBinaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScanResult> {
        const response = await this.scanSyncBinaryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for scanSyncDownloadPost without sending the request
     */
    async scanSyncDownloadPostRequestOpts(requestParameters: ScanSyncDownloadPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['syncDownloadScanRequest'] == null) {
            throw new runtime.RequiredError(
                'syncDownloadScanRequest',
                'Required parameter "syncDownloadScanRequest" was null or undefined when calling scanSyncDownloadPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scan/sync/download`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SyncDownloadScanRequestToJSON(requestParameters['syncDownloadScanRequest']),
        };
    }

    /**
     * Download a file from a remote location (HTTP/HTTPS), scan the file, and return the scan result.
     */
    async scanSyncDownloadPostRaw(requestParameters: ScanSyncDownloadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScanResult>> {
        const requestOptions = await this.scanSyncDownloadPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScanResultFromJSON(jsonValue));
    }

    /**
     * Download a file from a remote location (HTTP/HTTPS), scan the file, and return the scan result.
     */
    async scanSyncDownloadPost(requestParameters: ScanSyncDownloadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScanResult> {
        const response = await this.scanSyncDownloadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for scanSyncS3Post without sending the request
     */
    async scanSyncS3PostRequestOpts(requestParameters: ScanSyncS3PostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['syncS3ScanRequest'] == null) {
            throw new runtime.RequiredError(
                'syncS3ScanRequest',
                'Required parameter "syncS3ScanRequest" was null or undefined when calling scanSyncS3Post().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scan/sync/s3`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SyncS3ScanRequestToJSON(requestParameters['syncS3ScanRequest']),
        };
    }

    /**
     * Download a file from S3, scan the file, and return the scan result. A bucket policy is required to grant attachmentAV access to the S3 objects.
     */
    async scanSyncS3PostRaw(requestParameters: ScanSyncS3PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScanResult>> {
        const requestOptions = await this.scanSyncS3PostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScanResultFromJSON(jsonValue));
    }

    /**
     * Download a file from S3, scan the file, and return the scan result. A bucket policy is required to grant attachmentAV access to the S3 objects.
     */
    async scanSyncS3Post(requestParameters: ScanSyncS3PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScanResult> {
        const response = await this.scanSyncS3PostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usageGet without sending the request
     */
    async usageGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/usage`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get remaining credits and quota.
     */
    async usageGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Usage>> {
        const requestOptions = await this.usageGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsageFromJSON(jsonValue));
    }

    /**
     * Get remaining credits and quota.
     */
    async usageGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Usage> {
        const response = await this.usageGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for whoamiGet without sending the request
     */
    async whoamiGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/whoami`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get information about yourself.
     */
    async whoamiGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Whoami>> {
        const requestOptions = await this.whoamiGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WhoamiFromJSON(jsonValue));
    }

    /**
     * Get information about yourself.
     */
    async whoamiGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Whoami> {
        const response = await this.whoamiGetRaw(initOverrides);
        return await response.value();
    }

}
